import { useQuery, useQueryClient } from '@tanstack/react-query';
import { backendServices } from 'common';
import { useCallback } from 'react';

async function fetchCompanyUserProfile({
    buyerCompanyId,
    supplierCompanyId,
}: {
    buyerCompanyId: number;
    supplierCompanyId: number;
}) {
    const api = new backendServices.Apis.CompanyApi();

    const res = await api.getCompanyUserProfile({
        buyerCompanyId: buyerCompanyId!,
        supplierCompanyId: supplierCompanyId!,
    });

    return res.data;
}

export function useGetCompanyUserProfile({
    buyerCompanyId,
    supplierCompanyId,
}: {
    buyerCompanyId?: number;
    supplierCompanyId?: number;
}) {
    const query = useQuery(
        ['CompanyUserProfile', buyerCompanyId, supplierCompanyId],
        async () => fetchCompanyUserProfile({ supplierCompanyId: supplierCompanyId!, buyerCompanyId: buyerCompanyId! }),
        {
            enabled: !!supplierCompanyId && !!buyerCompanyId,
            staleTime: Infinity,
            cacheTime: Infinity,
        }
    );

    return query;
}

export function usePrefetchCompanyUserProfile() {
    const queryClient = useQueryClient();

    const prefetch = useCallback(
        async ({ buyerCompanyId, supplierCompanyId }: Parameters<typeof fetchCompanyUserProfile>[0]) => {
            await queryClient.prefetchQuery({
                queryKey: ['CompanyUserProfile', buyerCompanyId, supplierCompanyId],
                queryFn: async () =>
                    fetchCompanyUserProfile({
                        supplierCompanyId: supplierCompanyId,
                        buyerCompanyId: buyerCompanyId,
                    }),
                cacheTime: Infinity,
            });
        },
        [queryClient]
    );

    return prefetch;
}
